module.exports = __webpack_public_path__ + "static/img/img_aicc_07.b0c9c48.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/img_aicc_07.jpg
// module id = Oc9H
// module chunks = 1